import { Component } from '@angular/core';
import { NavController } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import { AuthEventsService } from './auth/services/events.service';
import { AuthRepository } from './auth/state/auth.repository';
import { DatabaseManager } from './classes/database-manager.class';
import { AppRepository } from './state/app.repository';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {

  production: boolean = false;
  menu = [];
  dbManager = new DatabaseManager()

  constructor(
    private appRep: AppRepository,
    private authRep: AuthRepository,
    private events: AuthEventsService,
    private navCtrl: NavController,
  ) {
    this.production = environment.production;

    this.authRep.state$.subscribe(state => {
      this.menu = []
      if (state.user?.admin && state.user?.role == 'admin') {
        this.menu.push({ title: 'Admin', url: '/admin', icon: { name: 'apps' } })
      }
      if (state.user?.admin && ['admin', 'manager'].includes(state.user?.role)) {
        this.menu.push({ title: 'Gerenciar', url: '/manager', icon: { name: 'apps' } })
      }
      this.menu.push({ title: 'Home', url: '/dashboard', icon: { name: 'home' } })
      if (state.user?.training) {
        this.menu.push({ title: 'Treinamento', url: '/weeks', icon: { name: 'barbell' } })
      }

      this.menu.push({
        title: 'Ajuda',
        fnc: () => {
          const base = './assets/content'
          const url = (state.user?.training) ? `${base}/ajuda_com_exercicio.pdf` : `${base}/ajuda_sem_exercicio.pdf`
          window.open(url, '_system', 'location=yes');
        },
        icon: { name: 'help-circle' }
      })

      this.menu.push({
        title: 'Tour', fnc: () => {
          this.tour(state)
        }, icon: { name: 'logo-youtube' }
      })

      this.menu.push({
        title: 'Sair', fnc: () => {
          this.logout()
        }, icon: { name: 'log-out' }
      })
    })

    this.listenToEvents()
  }

  listenToEvents() {
    this.events
      .unauthenticated
      .subscribe(() => {
        this.logout()
      })
  }

  logout() {
    this.appRep.reset();
    this.authRep.reset();
    this.dbManager.dropDbs();
    this.navCtrl.navigateRoot('/login')
  }

  tour(state) {
    const url = (state.user?.training) ? 'https://www.youtube.com/watch?v=Cq1upMVIt3g' : 'https://youtube.com/shorts/UKCABgOrvq4';
    window.open(url, '_blank');
  }
}
